import React, { useState, useEffect } from 'react';
import ProductSearch from './ProductSearch';
import PlaceComponent from './place.component';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

// Get configuration from global window object if available
const getConfig = () => {
  if (typeof window !== 'undefined' && window.STORE_LOCATOR_CONFIG) {
    return window.STORE_LOCATOR_CONFIG;
  }
  return {};
};

// Helper functions for fetching location
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const ProductOnlyView = () => {
  const [shopperLocation, setShopperLocation] = useState(null);
  const [initialSearchTerm, setInitialSearchTerm] = useState('');
  
  // Get config values with defaults
  const config = getConfig();

  useEffect(() => {
    // Check URL for search parameter
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const searchParam = urlParams.get('search');
      if (searchParam) {
        setInitialSearchTerm(searchParam);
      }
    }

    // Try to get location from cookies first
    const savedLocation = cookies.get('shopperLocation');
    if (savedLocation && savedLocation.city && savedLocation.state && savedLocation.lat && savedLocation.lng) {
      setShopperLocation({
        city: savedLocation.city, 
        state: savedLocation.state, 
        lat: savedLocation.lat, 
        lng: savedLocation.lng
      });
    } else {
      // If no cookie, use storerocket to get the default location
      fetch('https://storerocket.io/api/location')
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          const newLocation = {
            city: data.city, 
            state: data.state, 
            lat: data.lat, 
            lng: data.lon
          };
          setShopperLocation(newLocation);
          cookies.set('shopperLocation', newLocation, { path: '/' });
          if (process.env.NODE_ENV === 'development') {
            console.log('Setting cookie from Store Rocket');
          }
        })
        .catch(error => {
          console.error('Request failed:', error);
          // Fallback to Boston, MA if geolocation fails
          const fallbackLocation = {
            city: 'Boston',
            state: 'MA', 
            lat: 42.3601,
            lng: -71.0589
          };
          setShopperLocation(fallbackLocation);
          cookies.set('shopperLocation', fallbackLocation, { path: '/' });
          if (process.env.NODE_ENV === 'development') {
            console.log('Setting cookie to default Boston, MA due to geolocation failure');
          }
        });
    }
  }, []);

  const handlePlaceChanged = (current) => {
    const place = current.getPlace();
    if (place) {
      const [city, state] = extractCityState(place.address_components);
      if (process.env.NODE_ENV === 'development') {
        console.log('Setting cookie from Google Autocomplete');
      }
      
      const newLocation = {
        city: city,
        state: state,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      
      setShopperLocation(newLocation);
      cookies.set('shopperLocation', newLocation, { path: '/' });
      
      // Update URL with new location
      if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        
        // Set tab parameter to products
        url.searchParams.set('tab', 'product-search');
        
        // Update the location parameter
        if (city) {
          const locationStr = `${city}${state ? `, ${state}` : ''}`;
          url.searchParams.set('location', locationStr);
          
          // Keep any existing search parameter
          const searchParam = url.searchParams.get('search');
          
          window.history.pushState({
            location: locationStr,
            search: searchParam
          }, '', url.toString());
        }
      }
    }
  };

  const extractCityState = (address_components) => {
    let city = null;
    let state = null;

    address_components.forEach(element => {
      let index = element['types'].indexOf('locality');
      if (index >= 0) {
        city = element['long_name'];
      }
      index = element['types'].indexOf('administrative_area_level_1');
      if (index >= 0) {
        state = element['short_name'];
      }
    });
    return [city, state];
  };

  return (
    <div className="store-selector product-only-view">
      <div className="auto-complete">
        <PlaceComponent placeholder={shopperLocation} handlePlaceChanged={handlePlaceChanged} />
      </div>
      <ProductSearch 
        shopperLocation={shopperLocation}
        initialSearchTerm={initialSearchTerm}
      />
    </div>
  );
};

export default ProductOnlyView;
